var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgGoogle = function SvgGoogle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.229 4.366a4.347 4.347 0 0 0-3.07-1.2c-2.085 0-3.856 1.406-4.49 3.3v.005a4.792 4.792 0 0 0 0 3.062h.002c.635 1.893 2.405 3.301 4.492 3.301 1.078 0 2.003-.276 2.72-.763a3.703 3.703 0 0 0 1.6-2.432H8.16V6.56h7.546c.094.535.138 1.081.138 1.625 0 2.434-.87 4.491-2.383 5.884v.001C12.138 15.292 10.318 16 8.16 16a8.001 8.001 0 0 1-7.15-4.406v-.002a8.007 8.007 0 0 1 .002-7.181L1.01 4.41A7.998 7.998 0 0 1 8.16 0a7.689 7.689 0 0 1 5.353 2.082l-2.284 2.284Z"
  })));
};
export default SvgGoogle;